<template>
  <div v-if="loading" class="loading">
    <div class="loading-spinner"></div>
  </div>
  <NetworkSecurity v-else-if="hasWork && isWorkIdIncluded && !work.main" :work="work" />
  <div v-else-if="hasWork" :class="['work-wrap', work.id]">
    <div class="work-brief">
      <div class="work-brief-content">
        <div class="work-brief-text">
          <span class="animation-text company">{{ work.company }}</span>
          <break-text
            class="animation-text name"
            :content="(!isSP ? work?.namePC : work.name) || work.name"
          />
          <break-text
            class="animation-text des"
            :content="(!isSP ? work?.descriptionPC : work?.descDetail) || work.description"
            :isSpanBlock="true"
          />
        </div>
        <div :class="['screen-shoots', !imageLoaded && 'placeholder']">
          <img :src="getImageUrl(work.screenShot1)" alt="" @load="onImageLoad" />
        </div>
      </div>
    </div>
    <div class="work-details">
      <div class="work-details-content">
        <div
          v-if="work.main"
          class="des-content work-main-rich-text"
          v-html="work.main"
        ></div>
      </div>
      <works-button containerClass="works-button" btnText="worksBtnTextInDetail" />
    </div>
  </div>
</template>

<script>
import usePageResource from '@/composables/usePageResource';
import BreakText from '@/components/common/BreakText.vue';
import NetworkSecurity from '@/components/NetworkSecurity/index.vue';
import useIsSP from '@/composables/useIsSP';
import WorksButton from '@/components/works-button/WorksButton.vue';

export default {
  components: {
    BreakText,
    NetworkSecurity,
    WorksButton,
  },
  name: 'work-detail',
  setup() {
    const { pr } = usePageResource('works');
    const { isSP } = useIsSP(500);
    return {
      pr,
      isSP,
    };
  },
  watch: {
    pr() {
      this.initData();
    },
    $route() {
      this.initData();
    },
  },
  data() {
    return {
      loading: false,
      work: {},
      imageLoaded: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.initData();
  },
  computed: {
    hasWork() {
      return Boolean(this.work?.name || this.work?.key);
    },
    isWorkIdIncluded() {
      return ['network-security', 'china-network-security', 'electronic-business-website'].includes(this.work.id);
    },
  },
  methods: {
    initData() {
      if (this.$route.name !== 'work-detail') return;

      const workId = this.$route.params.id;
      const works = Array.isArray(this.pr?.works) ? this.pr.works : [];

      if (!works.length) {
        this.loading = true;
        return;
      }

      const work = works.find((item) => item.id === workId);
      if (work) {
        this.loading = false;
        this.work = work;
      } else {
        this.loading = false;
        this.$router.replace('/');
      }
    },
    getImageUrl(imgName) {
      if (imgName) {
        if (/^(?:https?:|data:|blob:)/i.test(imgName) || imgName.startsWith('/')) {
          return imgName;
        }
        // eslint-disable-next-line global-require,import/no-dynamic-require
        return require(`./../assets/${imgName}`);
      }
      return '';
    },
    onImageLoad() {
      this.imageLoaded = true;
    },
  },
};
</script>

<style scoped lang="scss">
.works-button {
  margin-top: 90px;
  @media only screen and(max-width: 768px) {
    margin-top: 60px;
  }
}
.loading {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top-color: #333;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.work-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #222222;

  .work-brief {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 158px 24px 102px;
    background: #f1f3f4;

    &-content {
      max-width: 900px;
      width: 100%;
      display: flex;
      align-items: center;

      .screen-shoots {
        display: flex;
        gap: 24px;
        > img {
          width: 450px;
          height: 386px;
          object-fit: contain;
        }
      }
      @media only screen and(min-width: 1000px) {
        .placeholder {
          width: 464px;
          height: 386px;
        }
      }
      @media only screen and(max-width: 999px) {
        .placeholder {
          width: 345px;
          height: 280px;
        }
      }
    }

    &-text {
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .company {
        font-size: 16px;
        white-space: pre-wrap;
      }

      .name {
        margin: 17px 0 40px 0;
        font-size: 32px;
        font-weight: bold;
        line-height: 45px;
        overflow-wrap: break-word;
      }

      .des {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  .work-details {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 100px 24px 160px 24px;
    background: #ffffff;

    .work-details-content {
      max-width: 900px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .des-content {
        width: 100%;
        margin-bottom: 0;
        font-size: 16px;
        line-height: 28px;
        word-break: normal;
        overflow-wrap: break-word;
        line-break: strict;

        &:not(:last-child) {
          margin-bottom: 90px;
        }
      }

      .work-main-rich-text {
        :deep(p:not(:last-child)),
        :deep(ul:not(:last-child)),
        :deep(ol:not(:last-child)),
        :deep(blockquote:not(:last-child)) {
          margin-bottom: 28px;
        }

        :deep(ul),
        :deep(ol) {
          padding-left: 1.5em;
        }

        :deep(img) {
          display: block;
          max-width: 100%;
          height: auto;
          margin: 0 auto 28px;
        }
      }

    }
  }
}

@media only screen and (max-width: 999px) {
  .work-wrap {
    .work-brief {
      padding: 98px 24px 70px 24px;

      &-content {
        flex-direction: column;

        .screen-shoots {
          > img {
            width: auto;
            height: 280px;
          }
        }
      }

      &-text {
        width: 100%;
        margin-bottom: 40px;
        align-items: center;
        text-align: center;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .work-wrap {
    .work-brief {
      &-text {
        .company {
          font-size: 14px;
          line-height: 20px;
        }

        .name {
          margin: 6px 0 16px;
          font-size: 26px;
          line-height: 40px;
        }

        .des {
          font-size: 13.5px;
        }
      }
    }

    .work-details {
      padding: 60px 24px 100px 24px;

      .work-details-content {
        .des-content {
          font-size: 14px;

          &:not(:last-child) {
            margin-bottom: 40px;
          }
        }

      }
    }
  }

}
@media only screen and (max-width: 375px) {
  .lingwei-anfou {
    .work-brief-text {
      .name {
        font-size: 26px;
      }
    }
  }
  .kuraray-dx {
    .work-brief-text {
      .name {
        font-size: 24px;
      }
    }
  }
}
</style>
